import { Component, NgModule,ViewChild, OnInit } from '@angular/core';
import { CommonModule,Location } from '@angular/common';
import { NotifyService } from 'src/app/home/services/notify.service';
import { MasterdataService } from 'src/app/home/services/masterdata.service';
import { timestampFormat } from '../../../../../app/config/moment';
import { PaginationComponent } from '../../../common/pagination/pagination.component';
import { AlertsService } from 'src/app/home/services/alerts.service';
import { MatDialog } from '@angular/material/dialog';
import { CloseAlertComponent } from '../close-alert/close-alert.component';
import { Router } from '@angular/router';
import { HomeService } from 'src/app/home/services/home.service';

@Component({
  selector: 'app-alert-list',
  standalone: true,
  imports: [CommonModule,
    PaginationComponent],
  templateUrl: './alert-list.component.html',
  styleUrls: ['./alert-list.component.scss', '../../../../app.component.scss']
})

export class AlertListComponent implements OnInit{
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  searchTerm: string = ''; 
  public alerts: any = [];
  public timestampFormat = timestampFormat;
  public paginationData: any = { totalPage: 0 };
  public currentPage: number = 1;
  selectedAlert: any; 

  public selectedTypeForAlert = [];
  public selectedStatusForAlert = [];
  public isFilter = false;
  public isFilterResult = true;
  public raisedSortValue: string;
  public resolvedSortValue: string;
  public orderBy:string = "asc";

  public searchText:string = "";

  constructor(public location: Location, public dialog: MatDialog, public homeService: HomeService,public notifyService: NotifyService,public masterdataService: MasterdataService,public alertsService: AlertsService,private router: Router) { }

  ngOnInit(): void {
    this.getalertList(this.currentPage, this.selectedTypeForAlert, this.selectedStatusForAlert, this.raisedSortValue, this.resolvedSortValue)
  }

  goBack(){
    this.location.back();
  } 

  resetSearch(): void {
    this.searchTerm = '';
    this.getalertList(this.currentPage, this.selectedTypeForAlert, this.selectedStatusForAlert, this.raisedSortValue, this.resolvedSortValue)
  }

  getalertList(currentPage: number, selectedTypeForAlert: Array<String> = [], selectedStatusForAlert: Array<Number> = [], raisedSortValue: String = "", resolvedSort: String = "") {
    this.alertsService.getalertList(currentPage, selectedTypeForAlert, selectedStatusForAlert, raisedSortValue, resolvedSort).subscribe((res) => {
      if (res.data) {
        this.alerts = res.data.data;
        this.paginationData.totalPage = Math.ceil(res.data.total / 15);
      }
    });
  }
 
  getQueryPage(event:any){
    console.log(event);
    this.currentPage = event;
    this.getalertList(this.currentPage, this.selectedTypeForAlert, this.selectedStatusForAlert, this.raisedSortValue, this.resolvedSortValue)
  }

  openDialog(alert: any): void {
    this.selectedAlert = alert;
    const dialogRef = this.dialog.open(CloseAlertComponent, {
      data: {
        cabinet_name: alert.cabinet_name,
        product_name: alert.product_name,
        status: alert.status,
        count: alert.count,
        id: alert.id,
        cabinet_id: alert.cabinet_id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.closeAlert(alert);
      }
    });
  }

  closeAlert(alert: any): void {
    this.homeService.closeAlert(alert.id).subscribe((res) => {
      if (res.success) {
        alert.is_closed = 1;
      }
    });
  }



  openTypesListPopup(event){
    document.getElementById("type_for-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("type_for-popup");
  }
  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active")
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }
  // onclick of type under type header
  onSelectType(event){
    console.log("event ",event);
    if (event.target.checked) {
      this.selectedTypeForAlert.push(event.target.value);
    }else{
      this.selectedTypeForAlert = this.selectedTypeForAlert.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;

    this.onFilterChange();
  } 

  onFilterChange(){
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }

    this.getalertList(this.currentPage, this.selectedTypeForAlert, this.selectedStatusForAlert, this.raisedSortValue, this.resolvedSortValue)
  }
 

  openStatusListPopup(event){
    document.getElementById("status_for-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("status_for-popup");
  }

  // onclick of type under type header
  onSelectStatus(event){
    if (event.target.checked) {
      this.selectedStatusForAlert.push(event.target.value);
    }else{
      this.selectedStatusForAlert = this.selectedStatusForAlert.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;

    this.onFilterChange();
  }


  raisedAtSort(){
    this.isFilter = true;

    if (this.raisedSortValue === "asc") {
      this.raisedSortValue = "desc";
    }else{
      this.raisedSortValue = this.orderBy;
    }

    this.onFilterChange();
  }
  
  resolvedSort(){
    this.isFilter = true; 

    if (this.resolvedSortValue === "asc") {
      this.resolvedSortValue = "desc";
    }else{
      this.resolvedSortValue = this.orderBy;
    }

    this.onFilterChange();
  }
  handleSearchText(){

  }
}
